import script from "./VuetablePaginationMixin.vue?vue&type=script&lang=js"
export * from "./VuetablePaginationMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__